import React from 'react';

const PixelIce = ({ className }) => (
 <div className="flex justify-center items-center">
	<svg with="100px" height="100px" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" fill="#000000" className={className}>
		<g id="SVGRepo_bgCarrier" stroke-width="0"></g>
		<g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
		<g id="SVGRepo_iconCarrier">
		<path fill="#1572B6" d="M22.063 20.72v44.03L96.22 98.03l-4.657 29.22 44.968 46.72-26.28 64.81 168.78 55.5v.564l-41.467 12.28 32.687 74.75-40.28-37.374-32.72-4.094-54.875-37.97 39.125 61.908 43.78-.563 52.564 47.876 33.312-7 186.28 94.594-42.623-87-29.188-127.906-38.563-37.375-9.343-48.47-34.44-32.72 12.25 74.19 56.064 63.06-11.094 39.126L386.344 301l-35.5-15.25-26.063 18.625 54.095 32.53-84.094-21.592 18.126-38.563-62.812-47.656-23.406-144.47-48.125-15.186 9.937 65.406 28.03 3.937-44.968 35.5-21.03-110.124-48.47-11.094-7.468-32.343h-72.53zm95.656 0l5.624 13.155 68.97 18.97-32.75-32.126h-41.845zm75.5 0l32.53 37.093-.813-37.094H193.22zm67.655 2.624l-15 38.5 6.72 33.562 23.25-33.562-14.97-38.5zm107.688 2.03L332.03 33.22l14.314 36.81 22.22-44.655zm-3.875 56.532l-7.47 36.188L388.126 112l-23.438-30.094zm-342.625 6.25v41.406L85 115.438l-62.938-27.28zm251.343 9.75l.125 33.813 56.94 54.593-23.22-83.22-33.844-5.187zm-202.03 38.438l-37.97 12.625 74.625 26.686-36.655-39.312zm197.5 19.344l9.53 68.062 56.406 40.656-5.156-53.437-60.78-55.282zm-245 7.75L89.75 235.28l12.344-40.686-78.22-31.156zm8.5 54.218l-11.688 39.72 41.374-14.126-29.687-25.594zM70.75 253.78l-17.094 28.25 32.063 13.94 69.686-25.19-84.656-17zm132.594 32.845l-52.438 1.25 51.125 36.344 24.032-2.47-22.718-35.125zM47.688 300.22l-19.626 28.374 37.22 1.812-17.594-30.187zm52.468 25.53l20.313 30.875 17.56-26.156-37.874-4.72z">
		</path>
		</g>
	</svg> 
  </div>

);

export default PixelIce;





